import { IconButton } from '@mui/material';
import { Icon } from 'components-new';
import { useEffect, useRef } from 'react';
import { BackpackReelProps } from './types';

export default function BackpackReel(props: BackpackReelProps) {
  const { items, openItem, show, onToggleBackpackModal } = props;

  if (!show) return null;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const reel = useRef(null);
  const scrollHorizontally = (e: any) => {
    if (reel) {
      e = window.event || e;
      const delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      reel.current.scrollLeft -= delta * 10; // Multiplied by 40
      e.preventDefault();
    }
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (reel) {
      reel.current.addEventListener('DOMMouseScroll', scrollHorizontally, false);
      reel.current.addEventListener('mousewheel', scrollHorizontally, false);
    }
  }, []);
  return (
    <div id="reel-bar">
      <IconButton
        size="small"
        sx={{ position: 'absolute', top: '5px', right: '5px' }}
        onClick={onToggleBackpackModal}
      >
        <Icon icon="fa-times" />
      </IconButton>
      <div
        className="scroll-div"
        style={{ width: `${170 * items.length}px`, marginLeft: 7 }}
        ref={reel}
      >
        {items.map((item: any) => (
          <div
            key={item.id}
            onClick={() => {
              openItem(item.origin, item.type);
            }}
            className="preview"
            style={{
              backgroundImage: `url(${item?.preview})`,
              backgroundSize: 'contain',
              marginTop: '15px',
            }}
          >
            {item.title && (
              <span
                style={{
                  backgroundColor: 'rgb(0 0 0 / 50%)',
                  bottom: 0,
                }}
                className="image-title"
              >
                {item.title}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
